import { default as _advancedFilters } from './advancedFilters.json';
import { default as _agentMgmt } from './agentMgmt.json';
import { default as _attributesMgmt } from './attributesMgmt.json';
import { default as _automation } from './automation.json';
import { default as _bulkActions } from './bulkActions.json';
import { default as _campaign } from './campaign.json';
import { default as _cannedMgmt } from './cannedMgmt.json';
import { default as _chatlist } from './chatlist.json';
import { default as _contact } from './contact.json';
import { default as _contactFilters } from './contactFilters.json';
import { default as _conversation } from './conversation.json';
import { default as _csatMgmtMgmt } from './csatMgmt.json';
import { default as _generalSettings } from './generalSettings.json';
import { default as _inboxMgmt } from './inboxMgmt.json';
import { default as _integrationApps } from './integrationApps.json';
import { default as _integrations } from './integrations.json';
import { default as _labelsMgmt } from './labelsMgmt.json';
import { default as _login } from './login.json';
import { default as _report } from './report.json';
import { default as _resetPassword } from './resetPassword.json';
import { default as _setNewPassword } from './setNewPassword.json';
import { default as _settings } from './settings.json';
import { default as _signup } from './signup.json';
import { default as _teamsSettings } from './teamsSettings.json';
import { default as _whatsappTemplates } from './whatsappTemplates.json';
import { default as _helpCenter } from './helpCenter.json';
import { default as _file } from './fileMgmt.json';
import { default as _roles } from './rolesMgmt.json';
import { default as _notes } from './closingNotesMgmt.json';
import { default as _workflows } from './workflows.json';
import { default as _builderSteps } from './builderSteps.json';
import { default as _checkEmail } from './checkEmail.json';
import { default as _conversationLogs } from './conversationLogs.json';
import { default as _auditLogs } from './auditLogs.json';
import { default as _agentBots } from './agentBots.json';
import { default as _salla } from './salla.json';
import { default as _subscription } from './subscription.json';
import { default as _settingAI } from './settingAI.json';
import { default as _locationSharing } from './locationSharing.json';
import { default as _zid } from './zid.json';
import { default as _integrationPanel } from './integrationPanel.json';

export default {
  ..._advancedFilters,
  ..._agentMgmt,
  ..._attributesMgmt,
  ..._automation,
  ..._campaign,
  ..._cannedMgmt,
  ..._auditLogs,
  ..._chatlist,
  ..._contact,
  ..._contactFilters,
  ..._conversation,
  ..._csatMgmtMgmt,
  ..._generalSettings,
  ..._inboxMgmt,
  ..._integrationApps,
  ..._integrations,
  ..._labelsMgmt,
  ..._login,
  ..._report,
  ..._resetPassword,
  ..._setNewPassword,
  ..._settings,
  ..._signup,
  ..._teamsSettings,
  ..._whatsappTemplates,
  ..._bulkActions,
  ..._helpCenter,
  ..._file,
  ..._roles,
  ..._workflows,
  ..._builderSteps,
  ..._notes,
  ..._checkEmail,
  ..._conversationLogs,
  ..._agentBots,
  ..._salla,
  ..._subscription,
  ..._settingAI,
  ..._locationSharing,
  ..._zid,
  ..._integrationPanel,
};
